<template>
  <div class="flex grow-0">
    <icon-base height="16" width="16" viewBox="0 0 16 16" :icon="icon" />
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";

import IconFailBigRed from "@/components/icons/IconFailBigRed.vue";
import IconSuccessBigGreen from "@/components/icons/IconSuccessBigGreen.vue";

import type { IApplication } from "@/models/applications";
import type { PropType } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number, Boolean],
    default: null,
  },
  model: {
    type: Object as PropType<IApplication>,
    default: null,
  },
  stage: {
    type: Number,
    default: null,
  },
  resolve: {
    type: Function as PropType<(row: IApplication) => boolean>,
  },
});

const icon = computed(() => {
  return props.resolve?.(props.model) ? IconSuccessBigGreen : IconFailBigRed;
});
</script>
